var React = require('react');

function VinylBgInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("circle",{"cx":"185","cy":"185.8","r":"182.5","fill":"#685C97","stroke":"#685C97","strokeWidth":"5"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"370","height":"370","fill":"white","transform":"translate(0 0.799988)"})))]);
}

VinylBgInline.defaultProps = {"width":"370","height":"371","viewBox":"0 0 370 371","fill":"none"};

module.exports = VinylBgInline;

VinylBgInline.default = VinylBgInline;
